module.exports = __webpack_public_path__ + "img/deadinburgh3.73fe8c2b.jpg";